import React from 'react';
import Marquee from 'react-fast-marquee';
import { motion } from 'framer-motion';
import { useLanguage } from './LanguageContext';
import {
  PhoneFrame,
  ScreenMatch,
  ScreenPlanner,
  ScreenShopping,
  ScreenDiscover,
  ScreenRecipe,
} from './PhoneMockup';

export const Gallery = () => {
  const { t } = useLanguage();

  const screens = [
    { id: 'discover', el: <ScreenDiscover /> },
    { id: 'match', el: <ScreenMatch /> },
    { id: 'recipe', el: <ScreenRecipe /> },
    { id: 'planner', el: <ScreenPlanner /> },
    { id: 'shopping', el: <ScreenShopping /> },
  ];

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-24 md:py-32 bg-orange-500 overflow-hidden"
    >
      {/* heading */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <motion.span
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="inline-block px-3 py-1 rounded-full bg-white/20 backdrop-blur text-white text-xs font-bold mb-5"
          >
            {t.gallery.eyebrow}
          </motion.span>
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.05 }}
            className="font-display font-extrabold text-white text-4xl md:text-5xl lg:text-6xl tracking-tight text-balance"
          >
            {t.gallery.title}
          </motion.h2>
        </div>
      </div>

      {/* Marquee */}
      <div className="mt-16 -rotate-2">
        <Marquee
          speed={45}
          gradient={false}
          pauseOnHover
          autoFill
          className="py-8"
        >
          {screens.map((s, i) => (
            <div key={`${s.id}-${i}`} className="mx-5 inline-block">
              <PhoneFrame>{s.el}</PhoneFrame>
            </div>
          ))}
        </Marquee>
      </div>

      {/* big background type */}
      <div className="pointer-events-none absolute inset-x-0 bottom-0 flex justify-center">
        <span
          className="font-display font-extrabold text-white/10 text-[180px] md:text-[260px] lg:text-[320px] leading-none tracking-tighter select-none"
          style={{ marginBottom: '-0.2em' }}
        >
          mealmatcher
        </span>
      </div>
    </section>
  );
};
